import {
  Component,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'app-reaction-button',
  imports: [],
  templateUrl: './reaction-button.component.html',
  standalone: true,
  styleUrl: './reaction-button.component.scss'
})
export class ReactionButtonComponent {
  reactionClicked = output<void>();
  isInWish = input(false);

  initWish() {
    this.reactionClicked.emit();
  }
}
